import { HandlerWithResult, replaceInChain } from "@insite/client-framework/HandlerCreator";
import {
    AddAttributeValueFilters,
    chain,
} from "@insite/client-framework/Store/Pages/ProductList/Handlers/AddProductFilters";
import { ProductListStateExtension } from "@tecumseh/Handlers/ProductListStateExtension";

type HandlerType = HandlerWithResult<ProductListStateExtension, ProductListStateExtension>;

export const AddAttributeValueFiltersExtension: HandlerType = props => {
    const currentFilters = props.getState().pages.productList.productFilters;
    props.result.attributeValueIds = currentFilters.attributeValueIds;
    if (!props.parameter.categoryId) {
        props.result.isInitialLoad = false;
    } else {
        delete props.result.isInitialLoad;
    }

    if (props.parameter.attributeValueIds) {
        props.result.attributeValueIds = props.parameter.attributeValueIds.concat(props.result.attributeValueIds || []);
    }
};

replaceInChain(chain, AddAttributeValueFilters, AddAttributeValueFiltersExtension);
